export const regex = {
    naturalNumber: /^[1-9]\d*$/,
    positiveNumber: /^\d+$/,
};
